/**
 * Accessibility: Add alt="" to img elements inside video.
 * Shopify's video_tag filter outputs <img> (poster fallback) without alt, causing Lighthouse image-alt failures.
 */
(function() {
  function fixVideoPosterAlt() {
    document.querySelectorAll('video > img').forEach(function(img) {
      if (!img.hasAttribute('alt')) {
        img.setAttribute('alt', '');
        img.setAttribute('role', 'presentation');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixVideoPosterAlt);
  } else {
    fixVideoPosterAlt();
  }
})();
